import { apiAddCreateNotificationListener, apiAddDeleteNotificationListener, apiAddUpdateNotificationListener, apiListNotifications, apiRemoveListener } from 'apis/NotificationApi';
import moment from 'moment';
import {
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';
import { useAuth } from './AuthContext';

const Context = createContext({});

export default function NotificationsProvider({ children }) {
  const { currentUser } = useAuth();
  const [notifications, setNotifications] = useState([]);

  const notificationsValid = notifications.filter(n => moment(n.endDate).endOf('day') >= new Date() && moment(n.startDate).startOf('day') <= new Date());

  /***** Processing *****/
  useEffect(() => {
    const listeners = [];
    const onCreateNotification = (notification) => {
      // update list
      setNotifications(prev => [notification, ...prev]);
    }
    const onUpdateNotification = (notification) => {
      // update list
      setNotifications(prev => {
        const index = prev.findIndex(g => g.id === notification.id);
        if (index === -1) return prev;
        prev[index] = notification;
        return [...prev];
      });
    }
    const onDeleteNotification = (notification) => {
      // update list
      setNotifications(prev => prev.filter(g => g.id !== notification.id));
    }
    const addListeners = async () => {
      await listNotifications();
      let listener = await apiAddCreateNotificationListener(onCreateNotification);
      listeners.push(listener);
      listener = await apiAddUpdateNotificationListener(onUpdateNotification);
      listeners.push(listener);
      listener = await apiAddDeleteNotificationListener(onDeleteNotification);
      listeners.push(listener);
    }
    if (currentUser) {
      addListeners();
    }
    return () => {
      while (true) {
        if (listeners.length === 0) break;
        apiRemoveListener(listeners.pop());
      }
    }
  }, [!!currentUser])

  const listNotifications = async () => {
    try {
      const res = await apiListNotifications();
      if (res.success) {
        setNotifications(res.data);
      }
    }
    catch (e) {
      // console.error("ERROR", e);
    }
  }


  /***** Main Render *****/
  return (
    <Context.Provider value={{ notifications, setNotifications, notificationsValid }}>
      {children}
    </Context.Provider>
  );
}

export const useNotifications = () => useContext(Context);
